import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { saveUser } from "redux/slice/authentication";
import { UserPartial } from "model/user";
import { getUserUnsafe } from "redux/selector";
import { RootState } from "redux/store";
import { Switch } from "component/shared/switch";
import * as env from "shared/env";

interface Props {
	checked?: boolean;
	onToggle?: (checked: boolean) => void;
}

export const FirstTouchTab: React.FC<Props> = ({ checked, onToggle }) => {
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => getUserUnsafe(state));
	
	const [firstTouchRouting, setFirstTouchRouting] = useState<boolean>(
		user?.firstTouchRouting || false
	);

	useEffect(() => {
		if (user) {
			setFirstTouchRouting(user.firstTouchRouting || false);
		}
	}, [user]);

	const handleSave = (checked: boolean) => {
		setFirstTouchRouting(checked);
		const userUpdate: UserPartial = {
			firstTouchRouting: checked,
		} as UserPartial;
		dispatch(saveUser({ user: userUpdate }) as any);
	};

	return (
		<Mui.Grid container direction="column" spacing={2}>
			<Mui.Grid item>
				<Switch
					checked={onToggle !== undefined ? !!checked : firstTouchRouting}
					label={env.refreshDesignsDev ? "Assign leads to the first agent page they visit" : "Enable First Touch Lead Attribution"}
					description={env.refreshDesignsDev ? (
						<>
							When enabled, leads are assigned to the first agent page they visit on your site, overriding all other routing rules. Note: this applies even when the Agent Selector is hidden — hiding an agent only removes manual selection, not attribution.
						</>
					) : (
						<>
							Route leads to the first agent page visited on a lead's initial visit to your site. The lead remains assigned to that agent for all future visits. Overrides other lead routing rules.
							<br />
							<br />
							First Touch applies even when the Agent Selector is hidden on forms—either sitewide or for individual agents. Hiding an agent from the dropdown only removes manual selection; it does not block attribution
						</>
					)}
					onChange={onToggle ?? handleSave}
				/>
			</Mui.Grid>
		</Mui.Grid>
	);
};
